// Chuyển dữ liệu hóa đơn (parse OCR từ doc-flatform) -> 1 dòng chi phí trong form.
// Tách khỏi PaymentRequestDrawer để logic tính tiền thuần & dễ kiểm thử.

const toDate = (v) => (v ? new Date(v) : null);

// Mỗi hóa đơn = 1 dòng. VND = tiền hàng (trước thuế), VAT riêng, Total = VND + VAT
// -> các cột luôn cộng khớp; tổng cộng dồn = sum các dòng.
export const invoiceToLine = (inv, emptyItem = {}) => {
  const isUSD = String(inv?.currency || "VND").toUpperCase() === "USD";
  const vat = Number(inv?.vat_amount) || 0;
  const subParsed = Number(inv?.amount_excl_vat) || 0;

  // Bù qua lại nếu thiếu: ưu tiên total_amount, rồi sub+vat, rồi amount/sub.
  let total = Number(inv?.total_amount) || 0;
  if (!total && subParsed) total = subParsed + vat;
  if (!total) total = Number(inv?.amount) || subParsed || 0;

  // sub = total - vat -> đảm bảo VND + VAT = Total. Guard âm.
  let sub = total - vat;
  if (sub < 0) sub = total;

  return {
    ...emptyItem,
    inv_date: toDate(inv?.inv_date),
    inv_no: inv?.inv_no || "",
    description: inv?.description || "",
    amount_vnd: isUSD ? 0 : sub,
    amount_usd: isUSD ? sub : 0,
    vat,
    total,
    doc_platform_document_id: inv?.document_id || inv?.doc_platform_document_id || "",
  };
};

// Auto-fill Hình thức thanh toán / số TK — chỉ áp dụng cho hóa đơn ĐẦU TIÊN.
// Payee giữ nguyên (tên Employee), KHÔNG lấy vendor.
export const invoiceAutofill = (inv) => {
  const out = {};
  if (inv?.payment_method) out.payment_method = inv.payment_method;
  if (inv?.bank_account) out.bank_account = inv.bank_account;
  return out;
};
